import { useContext } from "react";
import { AuthContext } from "../../../../../contexts/AuthContext";
import bannertop from "../../../../../assets/bannertop.png"

const Excel = require('exceljs');
const FileSaver = require('file-saver');


export default function GerarXlsx() {
    const { user } = useContext(AuthContext);

    const gerarXlsx = async (analytics, filter, enterprise) => {
        let client = '';
        Object.keys(enterprise).forEach((element, index) => {
            if (index != 0) {
                client = client + ", " + enterprise[index].nome_fantasia   
            } else {
                client = enterprise[index].nome_fantasia
            }
        });

        const mediumBlackBorder = { style: 'medium', color: { argb: '000' } };
        const thickBlackBorder = { style: 'thick', color: { argb: '000' } };
        const thinBlackBorder = { style: 'thin', color: { argb: '000' } };
        const dottedBlackBorder = { style: 'dotted', color: { argb: '000' } };

        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet("CREDOR", { views: [{ showGridLines: false }] });

        const logo = workbook.addImage({
            base64: bannertop,
            extension: 'png',
        });

        worksheet.addImage(logo, {
            tl: { col: 0, row: 1 },
            ext: { width: 233, height: 73 }
        })

        worksheet.mergeCells("J2:L3");
        worksheet.getCell('J2').value = "Relatório Estatístico - Analítico";
        worksheet.getCell("J2").font = { family: 4, size: 20, color: { argb: '002060' }, bold: true };
        worksheet.getCell('J2').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells("J4:L4");
        worksheet.getCell('J4').value = "Dados de Credor, Interno, Débito, Acordo e Finalização";
        worksheet.getCell("J4").font = { family: 4, color: { argb: '002060' }, bold: true };
        worksheet.getCell('J4').alignment = { vertical: 'middle', horizontal: 'center' };

        // dados do cliente e filtro

        worksheet.getCell('B8').value = "Cliente/Credor:";
        worksheet.getCell('B8').alignment = { vertical: 'bottom', horizontal: 'Left' };

        worksheet.mergeCells("B9:B9");
        worksheet.getCell('B9').value = client;
        worksheet.getCell("B9").font = { family: 4, color: { argb: 'ff3a3a' }, bold: true };
        worksheet.getCell('B9').alignment = { vertical: 'middle', horizontal: 'Left' };


        // filtros
        var n = 0;
        var linhaZ;

        Object.keys(filter).forEach((item, index) => {
            var linhaZ = String.fromCharCode(68 + n);
            switch (item) {
                case 'CNPJ':
                    worksheet.getCell(`${linhaZ}8`).value = 'CNPJ/CPF:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'devedor':
                    worksheet.getCell(`${linhaZ}8`).value = 'Cliene/Devedor:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'contrato':
                    worksheet.getCell(`${linhaZ}8`).value = 'Contrato:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'id_estagio':
                    worksheet.getCell(`${linhaZ}8`).value = 'Estágio:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'data_entrada':
                    worksheet.getCell(`${linhaZ}8`).value = 'Data de Entrada:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'titulo':
                    worksheet.getCell(`${linhaZ}8`).value = 'Título:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'vencimento':
                    worksheet.getCell(`${linhaZ}8`).value = 'Vencimento:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'valor_original':
                    worksheet.getCell(`${linhaZ}8`).value = 'Valor Original:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'saldo':
                    worksheet.getCell(`${linhaZ}8`).value = 'Saldo:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'data_acordo':
                    worksheet.getCell(`${linhaZ}8`).value = 'Data do Acordo:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'id_acordo':
                    worksheet.getCell(`${linhaZ}8`).value = 'Id do Acordo:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                case 'data_finalizacao':
                    worksheet.getCell(`${linhaZ}8`).value = 'Data da Finalização:';
                    worksheet.getCell(`${linhaZ}8`).alignment = { vertical: 'bottom', horizontal: 'Left' };
                    break;
                default:
                    break;
            }



            // worksheet.mergeCells("G9:H9");
            worksheet.getCell(`${linhaZ}9`).value = filter[item];
            worksheet.getCell(`${linhaZ}9`).font = { family: 4, color: { argb: 'ff3a3a' }, bold: true };
            worksheet.getCell(`${linhaZ}9`).alignment = { vertical: 'middle', horizontal: 'Left' };
            n = n + 3;
        });


        //Fim Filtros

        //Horizonta Lines
        worksheet.mergeCells("A7:L7");
        worksheet.getCell('A7').border = {
            top: thickBlackBorder,
            // bottom: mediumBlackBorder,
        };

        worksheet.mergeCells("A11:L11");
        worksheet.getCell('A11').border = {
            // top: thickBlackBorder,
            bottom: mediumBlackBorder,
        };

        worksheet.getRow(12).values = ['CNPJ/CPF \nCliente/Devedor', 'Cliene/Devedor', 'Contrato', 'Estágio', 'Data de Entrada', 'Título', 'Vencimento', 'Valor Original', 'Saldo', 'Data do Acordo', 'Id do Acordo', 'Data da Finalização',];
        worksheet.getRow(12).height = 30;
        worksheet.getRow(12).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        worksheet.columns = [
            { key: 'CNPJ', name: 'CNPJ/CPF \nCliente/Devedor', width: (Math.max.apply(Math, analytics.map((a) => a?.CNPJ.length)) + 3), },
            { key: 'devedor', name: 'Cliene/Devedor', width: (Math.max.apply(Math, analytics.map((a) => a?.devedor.length)) + 3) },
            { key: 'contrato', name: 'Contrato', width: (Math.max.apply(Math, analytics.map((a) => a?.contrato.length)) + 3) },
            { key: 'id_estagio', name: 'Estágio', width: (Math.max.apply(Math, analytics.map((a) => a?.status_acordo.length)) + 3) },
            { key: 'data_entrada', name: 'Data de Entrada', width: 12 },
            { key: 'titulo', name: 'Título', width: (Math.max.apply(Math, analytics.map((a) => a?.titulo.length)) + 3) },
            { key: 'vencimento', name: 'Vencimento', width: 18 },
            { key: 'valor_original', name: 'Valor Original', width: 20 },
            { key: 'saldo', name: 'Saldo', width: (Math.max.apply(Math, analytics.map((a) => a?.saldo.length)) + 3) },
            { key: 'data_acordo', name: 'Data do Acordo', width: 20 },
            { key: 'id_acordo', name: 'ID do acordo', width: 20 },
            { key: 'data_finalizacao', name: 'Data da Finalização', width: 20 },
        ];
        worksheet.getCell(`A12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`B12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
        worksheet.getCell(`C12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`D12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
        worksheet.getCell(`E12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`F12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`G12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`H12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`I12`).border = { bottom: mediumBlackBorder, right: mediumBlackBorder };
        worksheet.getCell(`J12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`K12`).border = { bottom: mediumBlackBorder, right: thinBlackBorder };
        worksheet.getCell(`L12`).border = { bottom: mediumBlackBorder };

        /*Let's say you stored your data in an array called arrData. Let's say that your arrData looks like this */
        const arrData = analytics;
        /* Now we use the keys we defined earlier to insert your data by iterating through arrData and calling worksheet.addRow()
        */
        var linha = 13;
        arrData.forEach(function (item, index) {
            worksheet.addRow({
                CNPJ: item.CNPJ,
                devedor: item.devedor,
                contrato: item.contrato,
                id_estagio: item.id_estagio,
                data_entrada: item.data_entrada ? new Date(item.data_entrada).toLocaleDateString('pt-Br') : '',
                titulo: item.titulo,
                vencimento: item.vencimento ? new Date(item.vencimento).toLocaleDateString('pt-Br') : '',
                valor_original: parseFloat(item.valor_original).toLocaleString('pt-Br', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                saldo: parseFloat(item.saldo).toLocaleString('pt-Br', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                data_acordo: item.data_acordo ? new Date(item.data_acordo).toLocaleDateString('pt-Br') : '',
                id_acordo: item.id_acordo,
                data_finalizacao: item.data_finalizacao ? new Date(item.data_finalizacao).toLocaleDateString('pt-Br') : '',
            });
            worksheet.getCell(`A${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`B${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`C${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`D${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`E${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`F${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`G${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`H${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`I${linha}`).border = { bottom: dottedBlackBorder, right: mediumBlackBorder };
            worksheet.getCell(`J${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`K${linha}`).border = { bottom: dottedBlackBorder, right: thinBlackBorder };
            worksheet.getCell(`L${linha}`).border = { bottom: dottedBlackBorder };


            linha++;
        })

        worksheet.mergeCells(`A${linha}:L${linha}`);
        worksheet.getCell(`A${linha}`).border = {
            bottom: thickBlackBorder,
            top: mediumBlackBorder,
        };
        linha += 2;
        worksheet.mergeCells(`A${linha}:L${linha}`);
        worksheet.getCell(`A${linha}`).value = `Data de extração ${new Date().toLocaleDateString('pt-BR')} | Extraído por: ${user?.email}`

        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), "VERSUO - Relat_Estat - Analitico.xlsx");
    }

    return {
        gerarXlsx
    }
}